import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "../components/ui/button";

export default function PageNotFound() {
    return (<>
        <Helmet>
            <title>404 - Page Not Found | Velozent</title>
            <meta name="description" content="The page you are looking for could not be found." />
            <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <motion.div
            className="flex min-h-[70vh] w-full items-center justify-center px-4 py-16 sm:min-h-[80vh] sm:px-6 lg:py-24"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            <motion.div
                className="max-w-xl text-center"
                initial={{ scale: 0.95, y: 20 }}
                animate={{ scale: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <motion.h1
                    className="mb-4 text-[clamp(3rem,10vw,5rem)] font-extrabold tracking-tight text-burnt-sienna-500"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                >
                    404
                </motion.h1>
                <p className="mb-6 text-balance text-lg font-semibold leading-snug text-shark-800 sm:text-xl lg:text-2xl">
                    Oops! The page you are looking for has not been found
                </p>
                <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    <Button asChild size="lg" className="text-base font-semibold">
                        <Link to="/">Go to Home</Link>
                    </Button>
                </motion.div>
            </motion.div>
        </motion.div>
    </>)

}
